export default __webpack_public_path__ + "static/media/avax.d567c107.svg";